export default "__VITE_ASSET__CymYDD5r__"